/**
 * Set header mega menu parents and non mega menu parents
 * (mega menu parent <li> should be posisiton static and non mega menu parent position absolute)
 */
function x_megamenu_setup_menu_parents() {

  var has_megamenu = false;
  var menu_items = document.querySelectorAll('.megamenu-pro__items > li');

  for (var i = 0; i < menu_items.length; i++) {
    if (menu_items[i].querySelector('.sub-megamenu--size-1')) {
      menu_items[i].classList.add('menu-item--has-tinymenu');
    } else {
      menu_items[i].classList.add('menu-item--has-megamenu');
    }
  }

}
x_megamenu_setup_menu_parents();

/**
 * Megamenu sub item toggle
 */
const x_megamenu_toggles = () => {

  const buttons = document.querySelectorAll('.js-terms-toggle');
  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener('click', (e) => {
      const li = e.currentTarget.parentNode.parentNode;
      if (li.getAttribute('aria-expanded') == 'true') {
        li.setAttribute('aria-expanded', 'false');
      } else {
        li.setAttribute('aria-expanded', 'true');
      }
    });
  }

  // make the call chainable
  return this;

};
x_megamenu_toggles();

/**
 * Auto-open and set to active items
 */
const x_megamenu_init_open_items = () => {

  let mobileActiveItems = document.querySelectorAll('.js-sub-megamenu-items .is-active, .mobile-menu-pro.js-mobile-menu .current-menu-item');
  for (let i = 0; i < mobileActiveItems.length; i++) {
    const item = mobileActiveItems[i];
    item.setAttribute('aria-expanded', 'true');
    let parentNode = item.parentNode;
    while (parentNode && parentNode.nodeName && parentNode.parentNode) {
      if (parentNode.nodeName == 'LI') {
        parentNode.setAttribute('aria-expanded', 'true');
      }
      if (parentNode.nodeName == 'UL') {
        parentNode.setAttribute('aria-hidden', 'false');
      }
      parentNode = parentNode.parentNode;
    }
  }

  let allActiveItems = document.querySelectorAll('.js-mobile-menu .megamenu-pro.js-navigation .current-menu-item, .js-megamenu-desktop-items .current-menu-item, .js-sub-megamenu-items .is-active, .js-navigation.megamenu-pro .is-active');
  console.log(allActiveItems);
  for (let i = 0; i < allActiveItems.length; i++) {
    const item = allActiveItems[i];
    let parentNode = item.parentNode;
    while (parentNode && parentNode.nodeName && parentNode.parentNode) {
      if (parentNode.nodeName == 'LI') {
        parentNode.classList.add('is-active');
      }
      parentNode = parentNode.parentNode;
    }
  }

};
x_megamenu_init_open_items();
